import { Environment, sendMailTriggerUrl } from "../../constants";
import { getAppEnv } from "../../helper/util";
import api from "../axiosBase";
import axios from "../department-viags/config.service";
import { RequestError } from "../requestError";
import { getURL } from "../serviceHelper";

interface IMailMessage {
  subject: string;
  contentType?: "html" | "text";
  content: string;
  address: string;
}

interface ISendMailByBotit {
  toMail: string;
  subject: string;
  content: string;
}

export class MailService {
  static async sendMail(message: any) {
    if (getAppEnv() !== Environment.production) {
      return;
    }

    return api
      .post(getURL(`/me/sendMail`), message)
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async sendMailByBotit(body: ISendMailByBotit) {
    return axios.post(sendMailTriggerUrl, body);
  }

  static buildMailMesssageBotit(eSubject: string, eContent: string, contentType: string, toRecipient: string) {
    return {
      message: {
        subject: eSubject,
        body: {
          contentType: contentType || "text",
          content: eContent,
        },
        toRecipients: [
          {
            emailAddress: {
              address: toRecipient,
            },
          },
        ],
        from: {
          emailAddress: {
            address: "botit@viags.vn",
          },
        },
      },
    };
  }

  static buildMailMesssage(eSubject: string, eContent: string, contentType: string, toRecipient: string) {
    return {
      message: {
        subject: eSubject,
        body: {
          contentType: contentType || "text",
          content: eContent,
        },
        toRecipients: [
          {
            emailAddress: {
              address: toRecipient,
            },
          },
        ],
      },
    };
  }

  static buildMailMesssageWithAttachment(
    eSubject: string,
    eContent: string,
    contentType: string,
    toRecipient: string,
    attachments: any[],
  ) {
    return {
      message: {
        subject: eSubject,
        body: {
          contentType: contentType || "text",
          content: eContent,
        },
        toRecipients: [
          {
            emailAddress: {
              address: toRecipient,
            },
          },
        ],
        attachments: attachments.map((e: any) => ({
          "@odata.type": "#microsoft.graph.fileAttachment",
          name: e.name,
          contentType: e.type,
          contentBytes: e.base64,
          size: e.size,
        })),
      },
    };
  }

  static getMessage({ subject, contentType = "text", content, address }: IMailMessage) {
    return {
      message: {
        subject,
        body: { contentType, content },
        toRecipients: [{ emailAddress: { address } }],
      },
    };
  }

  static buildMailMesssageForPeople(subject: string, content: string, contentType: string, recipients: string[]) {
    return {
      message: {
        subject: subject,
        body: {
          contentType: contentType || "text",
          content: content,
        },
        toRecipients: recipients.map((recipient) => {
          return {
            emailAddress: {
              address: recipient,
            },
          };
        }),
      },
    };
  }
}
